<h2 mat-dialog-title>{{ 'orders.confirmDelete' | transloco }}</h2>
<mat-dialog-content>{{ 'orders.areYouSureYouWantTo' | transloco }}</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close color="accent" [mat-dialog-close]="false">{{ 'common.buttons.close' | transloco }}</button>
  <span class="spacer"></span>
  <button mat-button mat-dialog-close color="warn" [mat-dialog-close]="true">{{ 'common.buttons.delete' | transloco }}</button>
</mat-dialog-actions>